import groupBy from 'lodash-es/groupBy';

import { isEmpty } from '@app/util/util';
import { TravelerItemUI } from '@pax/entities/pax-ui';
import {
  ActivitiesValidateResponse, ExtraInformationVM, ExtraQuestion, ExtraQuestionType
} from '@activities/entities/activities-booking';

export function getExtraInformationSection(list: TravelerItemUI[], validate: ActivitiesValidateResponse): ExtraInformationVM[] {
  const perActivityData = validate?.Products?.ProductsDetails.map((product, index) => ({
    Index: index,
    QuestionType: ExtraQuestionType.PerActivity,
    Title: product.ProductName,
    Questions: validate.ExtraQuestions.filter(question =>
      question.QuestionType === ExtraQuestionType.PerActivity && question.TravelerIndex === index
    ).map(q => ({
      ...q, FormKey: getFormKeyByQuestionCode(q.QuestionCode)
    }))
  })).filter(item => item.Questions?.length);
  const perPassengerData = list.map(ui => ({
    Index: ui.id,
    QuestionType: ExtraQuestionType.PerPassenger,
    Title: `${ui.defaultData?.first_name} ${ui.defaultData?.last_name}`,
    Questions: validate.ExtraQuestions.filter(question =>
      question.QuestionType === ExtraQuestionType.PerPassenger && question.TravelerIndex === ui.id
    ).map(q => ({
      ...q, FormKey: getFormKeyByQuestionCode(q.QuestionCode)
    }))
  })).filter(item => item.Questions?.length);
  const anotherQuestions = validate.ExtraQuestions.filter(q =>
    q.QuestionType === ExtraQuestionType.PerPassenger && !perPassengerData.map(ppq => ppq.Index).includes(q.TravelerIndex)
  );
  const groupByTravelerIndex = anotherQuestions.length ? groupBy(anotherQuestions, 'TravelerIndex') : {};
  const extraQuestions = !isEmpty(groupByTravelerIndex) ? Object.values(groupByTravelerIndex)
    .map((questions: ExtraQuestion[], index: number) => ({
      Index: index,
      QuestionType: ExtraQuestionType.PerPassenger,
      Title: '',
      Questions: questions.map(q => ({
        ...q, FormKey: getFormKeyByQuestionCode(q.QuestionCode)
      }))
    })) : [];
  return perPassengerData.concat(extraQuestions).concat(perActivityData);
}

export function getFormKeyByQuestionCode(questionCode: string): string {
  return `EXTRA_QUESTION_${questionCode.replace(/[^\w]/gi, '')}`;
}
